import { render, staticRenderFns } from "./WizardMenu.vue?vue&type=template&id=62d5d3c4&"
import script from "./WizardMenu.vue?vue&type=script&lang=ts&"
export * from "./WizardMenu.vue?vue&type=script&lang=ts&"
import style0 from "./WizardMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports